import React, { useEffect, useState, useMemo ,useCallback  } from "react";
import { withTranslation } from "react-i18next";
import { AllSecondaryDeploymentReport } from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { TableLoader } from "../../../Common/ShimmerLoader";
import TripsAndTonnageStore from "./store/useTripsAndTonnageStore";
import MUITable from "../../../Common/MUITable";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
const InnerTripsAndTonnageReport = ({ t }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const stateData = location?.state
    const localFilters = JSON.parse(localStorage.getItem("tripsFilter"));

    const fromDate = stateData?.fromDate || localFilters?.startDate || "";
    const toDate = stateData?.toDate || localFilters?.endDate || "";
    const zone = stateData?.zone || localFilters?.zoneId || "";
    // const { fromDate, toDate, zone } = data
    const { fetchInnerTripsAndTonnageApi, innerTripsAndTonnageReportData, loading } = TripsAndTonnageStore()
    const isProd = isGHMC();

     // ✅ What user has selected in dropdown (not yet applied)
    const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);

    // ✅ What is actually applied to the table (only set on Search click)
    const [appliedVehicleTypes, setAppliedVehicleTypes] = useState([]);

    // ✅ Build dropdown options from ALL data returned by API
    const vehicleTypeOptions = useMemo(() => {
        const types = innerTripsAndTonnageReportData
            .map((r) => r.vehicleType)
            .filter(Boolean);
        return [...new Set(types)]
            .sort()
            .map((type) => ({ label: type, value: type }));
    }, [innerTripsAndTonnageReportData]);

    // ✅ Filter only applied when Search is clicked
    const filteredData = useMemo(() => {
        if (!appliedVehicleTypes || appliedVehicleTypes.length === 0)
            return innerTripsAndTonnageReportData;

        const selectedValues = appliedVehicleTypes.map((opt) => opt.value);
        return innerTripsAndTonnageReportData.filter((r) =>
            selectedValues.includes(r.vehicleType)
        );
    }, [innerTripsAndTonnageReportData, appliedVehicleTypes]);

    // ✅ Search button — apply selected filter to table
    const handleSearch = () => {
        setAppliedVehicleTypes(selectedVehicleTypes);
    };

    // ✅ Clear button — reset both dropdown and table
    const handleClear = () => {
        setSelectedVehicleTypes([]);
        setAppliedVehicleTypes([]);
    };

    useEffect(() => {
        fetchInnerTripsAndTonnageApi(fromDate, toDate, zone);
    }, []);

    const formatDateForDisplay = (dateString) => {
        const date = new Date(dateString);
        const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
        return date.toLocaleString("en-GB", options).replace(",", "");
    };

    const options = { day: "numeric", month: "numeric", year: "numeric" };
    const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;


    const tripsAndTonnageColumns = [
        {
            label: "Vehicle Number",
            field: "vehicleNumber",
            render: (row) => row.vehicleNumber || "N/A",
        },
        {
            label: "Vehicle Type",
            field: "vehicleType",
            render: (row) => row.vehicleType || "N/A",
        },
        {
            label: "Driver Name",
            field: "driverName",
            render: (row) => (
                <div
                // onClick={() => handleShow(row)}
                >
                    {row.driverName || "N/A"}
                </div>
            ),
        },
        {
            label: "Driver Number",
            field: "mobileNumber",
            render: (row) => (
                <div
                // onClick={() => handleShow(row)}
                >
                    {row.mobileNumber || "N/A"}
                </div>
            ),
        },
        {
            label: "Date and Time",
            field: "createdDate",
            render: (row) => formatDateForDisplay(row.createdDate || "N/A"),
        },
        {
            label: "Tonnage Details",
            field: "netWeight",
            render: (row) => (row.netWeight || "N/A"),
        },

    ];

 
const downloadAsExcel = useCallback(async () => {

    
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Vehicle-Level Detailed Report of Waste Transportation ${formatDateForDisplay(fromDate)} to ${formatDateForDisplay(toDate)} - (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report on: ${generationTime}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Vehicle-Level Detailed Report of Waste Transportation");
    const boldFont = { bold: true };

    worksheet.addRow(["", downloadDateTime, ""]);
    worksheet.mergeCells(1, 1, 1, 5);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 6; col++) {
        worksheet.getCell(1, col).font = boldFont;
        worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }
    for (let col = 2; col <= 12; col++) {
        worksheet.getCell(2, col).font = boldFont;
        worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow(["", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(2, 1, 3, 8);
    worksheet.getCell(3, 2).value = cumulativeHeadingReport;
    worksheet.getCell(3, 2).font = boldFont;
    worksheet.getCell(3, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 12; col++) {
        worksheet.getCell(3, col).font = boldFont;
        worksheet.getCell(3, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Vehicle Number",
        "Vehicle Type",
        "Driver Name",
        "Driver Number",
        "Date & Time",
        "Tonnage Details",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" };
        if (colNumber >= 1 && colNumber <= 6) {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" },
            };
        }
    });

    // ✅ filteredData is now guaranteed to be the current filtered snapshot
    filteredData.forEach((item, index) => {
        worksheet.addRow([
            index + 1,
            item.vehicleNumber ?? "N/A",
            item.vehicleType ?? "N/A",
            item.driverName ?? "N/A",
            item.mobileNumber ?? "N/A",
            formatDateForDisplay(item.createdDate) || "N/A",
            item.netWeight ?? "N/A",
        ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 1 && colNumber <= 15) {
                cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
            } else {
                cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            }
        });
    });

    worksheet.columns = [
        { width: 5 },
        { width: 20 },
        { width: 30 },
        { width: 30 },
        { width: 30 },
        { width: 30 },
        { width: 30 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Vehicle-Level Detailed Report of Waste Transportation.xlsx";
    a.click();
    URL.revokeObjectURL(url);
}, [filteredData, fromDate, toDate, generationTime]); // ✅ dependency array ensures fresh filteredData
    return (
        <>
            {loading ? (
                <TableLoader height={500} />
            ) : (
                <div style={{ width: "100%" }}>
                    <div className="content">
                        <div className="page-content">
                            <h4 className="text-start ">
                                {t("Vehicle-Level Detailed Report of Waste Transportation")} ({formatDateForDisplay(fromDate)} to {formatDateForDisplay(toDate)}) (at {getCurrentDateTime1()})
                            </h4>                            
                            <div className="card mb-3">
                                <div className="card-body p-3">
                                    <div className="d-flex align-items-end gap-3 flex-wrap">          
                                        <div style={{ width: "280px", flexShrink: 0, flexGrow: 0 }}>
                                            <Select
                                                isMulti
                                                options={vehicleTypeOptions}
                                                value={selectedVehicleTypes}
                                                onChange={setSelectedVehicleTypes}
                                                placeholder="Select vehicle type(s)..."
                                                isClearable
                                                closeMenuOnSelect={false}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    container: (base) => ({
                                                        ...base,
                                                        width: "100%",        // ✅ fills the fixed parent div
                                                    }),
                                                    control: (base) => ({
                                                        ...base,
                                                        borderRadius: "6px",
                                                        borderColor: "#ced4da",
                                                        minHeight: "38px",
                                                        width: "100%",        // ✅ never grows beyond parent
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        flexWrap: "wrap",     // ✅ chips wrap DOWN
                                                        maxWidth: "240px",    // ✅ hard cap so chips can't push sideways
                                                    }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: "#e0f0ff",
                                                        borderRadius: "4px",
                                                        margin: "2px",
                                                        maxWidth: "200px",    // ✅ long names get truncated not expanded
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        color: "#0d6efd",
                                                        fontWeight: 500,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }),
                                                    multiValueRemove: (base) => ({
                                                        ...base,
                                                        color: "#0d6efd",
                                                        ":hover": {
                                                            backgroundColor: "#0d6efd",
                                                            color: "white",
                                                        },
                                                    }),
                                                }}
                                            />
                                        </div>
                                        {/* Search + Clear buttons */}
                                        <div className="d-flex gap-2">
                                            <button
                                                type="button"
                                                className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                                                onClick={handleSearch}
                                            >
                                                <i className="fa-solid fa-magnifying-glass me-1"></i> Search
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={handleClear}
                                            >
                                                Clear
                                            </button>
                                        </div>

                              <div className="d-flex justify-content-end gap-2">
                                <button
                                    type="button"
                                    className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                                    onClick={() =>
                                        navigate("/trips-tonnage-report", {
                                            state: { fromDate, toDate, zone },
                                        })
                                    }
                                >
                                    Back
                                </button>

                                <button className="btn btn-excel" onClick={downloadAsExcel}>
                                    <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                                </button>
                            </div>
                                    </div>
                                </div>
                            </div>
                            
                        

                            <div className="card">
                                <div className="card-body p-3">


                                    <div className="mt-3">
                                        <div className="">
                                            <MUITable loading={loading}
                                                needSRNumber
                                                columns={tripsAndTonnageColumns}
                                                rows={filteredData}  
                                                tableHeight={500}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}`;
};


export default withTranslation()(InnerTripsAndTonnageReport);